<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.cog-regular"></svg-vue>
          <h1 class="content-title">
            {{ $t('General') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-app" to="/admin/settings">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="content-card-body">
        <loading :status="loading.general"></loading>
        <form @submit.prevent="save">
          <div class="px-4 py-5 bg-white sm:p-6">
            <div class="grid grid-cols-3 gap-6">
              <div class="col-span-3">
                <label class="form-label" for="app_url">{{ $t('Site URL') }}</label>
                <div class="pt-1">
                  <input :placeholder="$t('App url')" class="form-input" id="app_url" required type="url" v-model="form.app_url" />
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="app_name">{{ $t('Site name') }}</label>
                <div class="pt-1">
                  <input :placeholder="$t('Site name')" class="form-input" id="app_name" required v-model="form.app_name" />
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="app_phone">{{ $t('Site Phone') }}</label>
                <div class="pt-1">
                  <input :placeholder="$t('Site Phone')" class="form-input" id="app_phone" v-model="form.app_phone" />
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="app_address">{{ $t('Address') }}</label>
                <div class="pt-1">
                  <input :placeholder="$t('Address')" class="form-input" id="app_address" v-model="form.app_address" />
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="app_about">{{ $t('About') }} </label>
                <div class="pt-1">
                  <textarea rows="5" :placeholder="$t('about')" class="form-input" id="app_about" v-model="form.app_about"></textarea>
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="app_https">{{ $t('Force HTTPS') }}</label>
                <input-switch
                  :disabled-label="$t('The site will load from any available protocol')"
                  :enabled-label="$t('The site will be forced to load with https')"
                  id="app_https"
                  v-model="form.app_https"
                ></input-switch>
                <div class="form-description-text">
                  {{ $t('Force the loading of the site using HTTPS, to improve the security and SEO positioning of the site') }}.
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="send_notification">{{ $t('Send Notifications') }}</label>
                <input-switch
                  :disabled-label="$t('All notifications disabled')"
                  :enabled-label="$t('All notifications enabled')"
                  id="send_notification"
                  v-model="form.send_notification"
                ></input-switch>
                <div class="form-description-text">{{ $t('This option will control the repair notifications status') }}.</div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="is_accepting_repair_order">{{ $t('Accepting repair orders') }}</label>
                <input-switch
                  :disabled-label="$t('The customer will not able to submit repair')"
                  :enabled-label="$t('The customer will able to submit repair')"
                  id="is_accepting_repair_order"
                  v-model="form.is_accepting_repair_order"
                ></input-switch>
                <div class="form-description-text">{{ $t('This option will control the repair booking from publicly') }}.</div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="is_processing_without_pay">{{ $t('Bypass all payment gateways') }}</label>
                <input-switch
                  :disabled-label="$t('The customer need to make payment to submit repair')"
                  :enabled-label="$t('The customer can submit repair without payment process')"
                  id="is_processing_without_pay"
                  v-model="form.is_processing_without_pay"
                ></input-switch>
                <div class="form-description-text">{{ $t('This option will control to bypass the payment gateways while repair booking') }}.</div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="portfolio_status">{{ $t('Public portfolio status') }}</label>
                <input-switch
                  :disabled-label="$t('The portfolio disabled')"
                  :enabled-label="$t('The portfolio activated')"
                  id="portfolio_status"
                  v-model="form.portfolio_status"
                ></input-switch>
                <div class="form-description-text">{{ $t('This option will control the repair box default portfolio publicly') }}.</div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="inline-flex">
              <button class="btn btn-app rounded-md shadow-sm" type="submit">
                {{ $t('Save') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="content-card-body">
        <form @submit.prevent="optimizeSystem">
          <loading :status="loading.optimize"></loading>
          <div class="px-4 py-5 bg-white sm:p-6">
            <div class="grid grid-cols-3 gap-6">
              <div class="col-span-3">
                <label class="form-label" for="action">{{ $t('System terminal') }}</label>
                <div class="pt-1">
                  <select class="form-input bg-white" id="action" required v-model="system.action">
                    <option :value="null" disabled>
                      {{ $t('Select an option') }}
                    </option>
                    <option value="optimize">{{ $t('Full optimize') }}</option>
                    <option value="cache">{{ $t('Clear only cache') }}</option>
                    <option value="storage_link">{{ $t('Refresh storage link') }}</option>
                    <option value="update">{{ $t('Install update') }}</option>
                  </select>
                </div>
              </div>
              <div class="col-span-3">
                <div v-if="system.output" class="overflow-auto p-5 bg-black rounded-md text-xs text-green-400 w-full">
                  <pre>{{ system.output }}</pre>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="inline-flex">
              <button :disabled="!system.action" class="btn btn-red" type="submit">
                {{ $t('Request') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'general',
  data() {
    return {
      loading: {
        optimize: false,
        general: true,
      },
      system: {
        action: 'optimize',
        output: null,
      },
      form: {
        app_url: null,
        app_name: null,
        app_https: null,
        app_address: null,
        app_phone: null,
        app_about: null,
        is_accepting_repair_order: false,
        is_processing_without_pay: false,
        portfolio_status: true,
        send_notification: true,
      },
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    get() {
      axios
        .get(route('settings.get.general'))
        .then((response) => {
          this.form = response.data;
          this.loading.general = false;
        })
        .catch(function() {
          this.$router.push('/admin/settings');
        });
    },
    optimizeSystem() {
      this.loading.optimize = true;
      this.system.output = null;
      axios
        .post(route('settings.optimize'), this.system)
        .then((response) => {
          this.loading.optimize = false;
          this.system.output = response.data.output;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          setTimeout(() => {
            this.system.output = null;
          }, 5000);
        })
        .catch(() => {
          this.loading.optimize = false;
        });
    },
    save() {
      this.loading.general = true;
      axios
        .post(route('settings.set.general'), this.form)
        .then((response) => {
          this.loading.general = false;
          window.app.name = this.form.app_name;
          window.app.is_acepting_repair = this.form.is_accepting_repair_order;
          window.app.is_processing_without_pay = this.form.is_processing_without_pay;
          this.$store.commit('setSettings', window.app);
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
        })
        .catch(() => {
          this.loading.general = false;
        });
    },
  },
};
</script>
